<template>
  <div class="customer-filter">
    <label :for="id">Customer</label><select :id="id" v-model="selected" @change="$emit('update:customer', selected)">
      <option v-if="!customers.length" value="">No customers available</option>
      <option v-for="customer in customers" :key="customer.id" :value="customer.id">
        {{ customer.company || customer.name || customer.id }}
      </option>
    </select>
  </div>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue'
import type { CustomerData } from '@/typings/Customers/CustomerData'
const props = defineProps<{ id: string; customers: CustomerData[] }>()
defineEmits<{ 'update:customer': [id: string] }>()
const selected = ref('')
watch(
  () => props.customers,
  (customers) => {
    if (!customers.some((c) => c.id === selected.value)) selected.value = customers[0]?.id || ''
  },
  { immediate: true },
)
</script>
<style scoped>
.customer-filter {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 180px;
  max-width: 100%;
}
label {
  font-size: 12px;
  font-weight: 400;
  color: #62766c;
}
select {
  font: inherit;
  font-size: 14px;
  min-height: 42px;
  border: 1px solid #d5e1da;
  border-radius: 6px;
  padding: 8px 10px;
  background: white;
  color: #204638;
  max-width: 100%;
}
select:focus-visible {
  outline: 3px solid #f6946b;
  outline-offset: 2px;
}
@media (max-width: 600px) {
  .customer-filter {
    width: 100%;
  }
  select {
    min-height: 44px;
  }
}
</style>
